import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  brands: null
}

const mutations = {
  setBrands(state, brands) {
    state.brands = brands
  }
}

export default new Vuex.Store({
  state,
  mutations
})